import React, {Fragment, useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {FormCheck, Table} from "react-bootstrap";
import {SET_SELECTED_SECTIONS} from "../../../Redux/Actions/Types/reportActionTypes";

export const ReportSections = (props) => {
    const dispatch = useDispatch();

    const {sections, selectedSections} = useSelector(state => state.reportState);
    const sectionTypes = [... new Set(sections.map( section => section.conservationActionTypeCode))];
    
    useEffect(() => {
        selectAllSections();
    }, [sections])
    
    const selectAllSections = () => {
        let selectedResult = {
            ...selectedSections,
        };

        sectionTypes.forEach( type => {
            selectedResult[type] = enabledSections(type)
                .map(section => section.procedureCode);
        });
        
        dispatch({type: SET_SELECTED_SECTIONS, selectedSections: selectedResult});
    }

    const toggleCheckbox = (type, value) => {
        const sectionValues = selectedSections[type] ?? [];
        let selectedResult;

        if (!sectionValues.includes(value)) {
            selectedResult = {
                ...selectedSections,
                [type]: [...sectionValues, value],
            };
        } else {
            selectedResult = {
                ...selectedSections,
                [type]: [...sectionValues].filter(item => item !== value),
            };
        }

        dispatch({type: SET_SELECTED_SECTIONS, selectedSections: selectedResult});
    };

    const toggleAll = (type) => {
        let selectedResult;

        if (allSelected(type)) {
            selectedResult = {
                ...selectedSections,
                [type]: [],
            };
        } else {
            selectedResult = {
                ...selectedSections,
                [type]: enabledSections(type)
                    .map(section => section.procedureCode),
            };
        }

        dispatch({type: SET_SELECTED_SECTIONS, selectedSections: selectedResult});
    };

    const enabledSections = (conservationActionTypeCode) => {
        return sections?.filter(section =>
            section.conservationActionTypeCode === conservationActionTypeCode &&
            (!section.requiresSampleEvent || !!section.SampleEvents?.length)
        );
    };

    const allSelected = (type) => {
        return enabledSections(type)
            .every(section => selectedSections[type]?.includes(section.procedureCode) ?? false);
    };

    const renderSectionCheckboxes = (type) => {
        return (
            <Fragment>
                <FormCheck
                    id={`${type}-select-all`}
                    label="Select All"
                    checked={allSelected(type)}
                    onChange={(x) => toggleAll(type)}
                />
                {
                    sections
                        ?.filter(section => type === section.conservationActionTypeCode)
                        .map(section => (
                            <FormCheck
                                id={`${type}-${section.procedureCode}`}
                                key={`${type}-${section.procedureCode}`}
                                label={`${section.name} (${section.SampleEvents?.length ?? 0})`}
                                checked={selectedSections[type]?.includes(section.procedureCode) ?? false}
                                onChange={(x) => toggleCheckbox(type, section.procedureCode)}
                                disabled={section.requiresSampleEvent && !section.SampleEvents?.length}
                            />
                        ))
                }
            </Fragment>
        )
    };

    if (!sections.length) {
        return null
    }

    return (
        <Fragment>
            <h3 className="table-headers">Report Sections</h3>
            <Table striped bordered size="sm" className="sb-model-viewer">
                <tbody>
                <tr>
                    <td className="sb-model-viewer-column"><label>Vegetation Monitoring for</label></td>
                    <td className="sb-model-viewer-column">{renderSectionCheckboxes('riparian-habitat')}</td>
                </tr>
                <tr>
                    <td className="sb-model-viewer-column"><label>Instream Monitoring for</label></td>
                    <td className="sb-model-viewer-column">{renderSectionCheckboxes('instream-habitat')}</td>
                </tr>
                </tbody>
            </Table>
        </Fragment>
    )

};


